<!-- Slider main container -->
<div class="swiper-container swiper-container-home">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
        <!-- Slides -->
        <div *ngFor="let movie of movies" (click)="onMovieClick( movie )" [ngStyle]="{
                'background-size': 'cover', 
                'background-image':'url(https://image.tmdb.org/t/p/w500' + movie.backdrop_path +')'
                }" class="swiper-slide" style="cursor: pointer;">
            <div class="movie-description">
                <h3>{{ movie.title}}</h3>
                <p> {{ movie.overview | slice:0:100}}</p>
            </div>
        </div>
    </div>
    <!-- If we need pagination -->
    <div class="swiper-pagination"></div>

    <!-- If we need navigation buttons -->
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>

    <!-- If we need scrollbar -->
    <div class="swiper-scrollbar"></div>
</div>